export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives18.583d18e5.jpg";